export default "__VITE_ASSET___3puoOKJ__"